import { COLORS } from '@/utils';

export const IconShare = ({
  color = COLORS['gdt-blue'].DEFAULT,
}: {
  color?: string;
}) => {
  return (
    <svg
      className="feather feather-share-2"
      fill="none"
      height="100%"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
      <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
    </svg>
  );
};
